import _ from 'lodash';
import angular from 'angular';
import 'background-check/background-check';

class HomeController {
  /* @ngInject */
  constructor(
    $rootScope,
    $state,
    $timeout,
    $window,
    $document,
    $transitions,
    HelperService
  ) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = null;
      // $rootScope.pageDescription = ''

      let assets = vm.landingPage.fields.assets.filter((asset) => {
        if (!$rootScope.$isDesktop && asset.schema === 'video') {
          return false;
        }
        if (
          $window.innerWidth > $window.innerHeight &&
          asset.thumbnail.ratio < 1
        ) {
          return false;
        }
        if (
          $window.innerWidth < $window.innerHeight &&
          asset.thumbnail.ratio > 1
        ) {
          return false;
        }
        return true;
      });

      if (!assets.length) {
        assets = vm.landingPage.fields.assets.filter((asset) => {
          if (!$rootScope.$isDesktop && asset.schema === 'video') {
            return false;
          }
          return true;
        });
      }

      vm.hero = _.sample(assets);
      // vm.hero = assets.filter(asset => asset.schema === 'video')[0];

      $rootScope.socialImage(
        HelperService.thumbnailSrc(
          vm.hero.thumbnail,
          'w:1500;h:1500;q:60;f:jpg'
        )
      );

      let navigatedAway = false;

      $transitions.onStart({}, () => {
        navigatedAway = true;
      });

      vm.imagesLoadedEvents = {
        done: (event) => {
          angular.element(event.elements[0]).addClass('loaded');

          if (vm.hero.schema === 'image') {
            $timeout(() => {
              if (navigatedAway || vm.showMenu) {
                return;
              }
              if ($state.$current.name === 'index.home') {
                $state.go('index.artists');
              }
            }, 5000);
          }
        },
      };

      let playCount = 0;
      vm.onVideoEnded = (event) => {
        playCount += 1;

        if (playCount === 1) {
          if ($state.$current.name === 'index.home') {
            if (navigatedAway || vm.showMenu) {
              return;
            }

            $state.go('index.artists');
          }
        }

        event.target.play();
      };

      // $timeout(() => {
      //   BackgroundCheck.init({
      //     targets: [
      //       $document[0].querySelector('.logo'),
      //       $document[0].querySelector('.caption'),
      //     ],
      //     images: '.hero figure',
      //     maxDuration: 5000,
      //     threshold: 50,
      //   })
      //   $timeout(() => {
      //     BackgroundCheck.refresh()
      //   }, 100)
      // });
    };
  }
}

export default HomeController;
